import React from 'react';
import { motion } from 'framer-motion';
import { AsteriskIcon } from 'lucide-react';
import { songs } from '../../data/site';
type RowProps = {
  reverse?: boolean;
  outlined?: boolean;
};
function MarqueeRow({
  reverse = false,
  outlined = false
}: RowProps) {
  const items = [...songs, ...songs];
  return <div className="flex overflow-hidden" data-id="element-143" data-mp="10njc3yjxt3e8">
      <motion.ul className="flex shrink-0 items-center gap-8 pr-8" animate={{
      x: reverse ? ['-50%', '0%'] : ['0%', '-50%']
    }} transition={{
      duration: 45,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-144" data-mp="10m8c89tm4fse">
        {items.map((song, i) => <li key={i} className="flex shrink-0 items-center gap-8" aria-hidden={i >= songs.length} data-id="element-145" data-mp="1eeo88qo3jdjt" data-mpi={i}>
            <span className={`whitespace-nowrap font-display text-4xl uppercase md:text-6xl ${outlined ? 'text-outline text-paper' : 'text-paper'}`} data-id="element-146" data-mp="1jdreufjq5rtw">
              {song}
            </span>
            <AsteriskIcon className="h-8 w-8 shrink-0 text-ink" aria-hidden data-id="element-147" data-mp="7xavib51ur1r" />
          </li>)}
      </motion.ul>
    </div>;
}
export function SongMarquee() {
  return <section aria-label="Titres joués en concert" className="relative z-10 -mt-4 overflow-hidden py-6" data-id="element-148" data-mp="39i20owb2rqkg">
      <div className="-rotate-2 scale-105 space-y-3 bg-signal py-5" data-id="element-149" data-mp="3ndxewouj4dhi">
        <MarqueeRow data-id="element-150" data-mp="3ig5pc1hcx3gh" />
        <MarqueeRow reverse outlined data-id="element-151" data-mp="3ifm6mijvub1e" />
      </div>
    </section>;
}